import { useCallback as $, useRef as D, useEffect as F } from "react";
import { c as g, g as M } from "./_commonjsHelpers-DaMA6jEr.js";
var N = "Expected a function", E = NaN, W = "[object Symbol]", A = /^\s+|\s+$/g, B = /^[-+]0x[0-9a-f]+$/i, _ = /^0b[01]+$/i, G = /^0o[0-7]+$/i, P = parseInt, H = typeof g == "object" && g && g.Object === Object && g, U = typeof self == "object" && self && self.Object === Object && self, X = H || U || Function("return this")(), q = Object.prototype, z = q.toString, J = Math.max, K = Math.min, T = function() {
  return X.Date.now();
};
function Q(e, t, r) {
  var o, f, c, s, i, a, d = 0, x = !1, m = !1, y = !0;
  if (typeof e != "function")
    throw new TypeError(N);
  t = S(t) || 0, v(r) && (x = !!r.leading, m = "maxWait" in r, c = m ? J(S(r.maxWait) || 0, t) : c, y = "trailing" in r ? !!r.trailing : y);
  function p(n) {
    var u = o, b = f;
    return o = f = void 0, d = n, s = e.apply(b, u), s;
  }
  function k(n) {
    return d = n, i = setTimeout(l, t), x ? p(n) : s;
  }
  function C(n) {
    var u = n - a, b = n - d, h = t - u;
    return m ? K(h, c - b) : h;
  }
  function I(n) {
    var u = n - a, b = n - d;
    return a === void 0 || u >= t || u < 0 || m && b >= c;
  }
  function l() {
    var n = T();
    if (I(n))
      return O(n);
    i = setTimeout(l, C(n));
  }
  function O(n) {
    return i = void 0, y && o ? p(n) : (o = f = void 0, s);
  }
  function L() {
    i !== void 0 && clearTimeout(i), d = 0, o = a = f = i = void 0;
  }
  function R() {
    return i === void 0 ? s : O(T());
  }
  function j() {
    var n = T(), u = I(n);
    if (o = arguments, f = this, a = n, u) {
      if (i === void 0)
        return k(a);
      if (m)
        return i = setTimeout(l, t), p(a);
    }
    return i === void 0 && (i = setTimeout(l, t)), s;
  }
  return j.cancel = L, j.flush = R, j;
}
function v(e) {
  var t = typeof e;
  return !!e && (t == "object" || t == "function");
}
function V(e) {
  return !!e && typeof e == "object";
}
function Y(e) {
  return typeof e == "symbol" || V(e) && z.call(e) == W;
}
function S(e) {
  if (typeof e == "number")
    return e;
  if (Y(e))
    return E;
  if (v(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = v(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = e.replace(A, "");
  var r = _.test(e);
  return r || G.test(e) ? P(e.slice(2), r ? 2 : 8) : B.test(e) ? E : +e;
}
var Z = Q;
const w = /* @__PURE__ */ M(Z), te = (e, t, r) => {
  const o = $(
    (c) => w(c, t, r),
    [t, r]
  ), f = D(
    o(e)
  );
  return F(() => (f.current = o(e), () => {
    var c;
    return (c = f.current) == null ? void 0 : c.cancel();
  }), [e, o]), f.current;
};
export {
  te as u
};
//# sourceMappingURL=use-debounce-CdWiiBgU.js.map
